export const getInitialState = () => ({
  data: {
    healthInsuranceVariables: [],
    healthInsuranceList: [],
    healthInsuranceRecentCards: [],
    healthInsuranceCardInfos: {
      cardNumber: ''
    },
  },
});

export const state = getInitialState();
